import React, { useEffect, useState } from 'react'
import { Button, Modal, Nav } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { deleteOrderItem, getCompletedOrdersListing, getOrdersListing, getRejectedOrdersListing } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Switch, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import viewIcon from "../../assets/svg/view.svg";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { FaRegSquarePlus } from 'react-icons/fa6';
import { FiPlus } from 'react-icons/fi';
import CreateBanner from './CreateBanner';
import { getInventoryListingPaginate } from '../../api/context/products';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { createBanner, deleteBannerItem, editBanner, getBannerListing, updateBannerStatus } from '../../api/context/banner';
import toast from 'react-hot-toast'
import imageToBase64 from 'image-to-base64/browser';
import { checkUserPermissions } from '../../helpers/permission';

const queueDatatableCustomStyles = {
    header: {
        style: {
            fontWeight: '600',
            fontSize: '22px',
            color: '#000',
        },
    },
    headCells: {
        style: {
            display: "flex",
            justifyContent: "center",
            fontWeight: '600',
            fontSize: '14px',
            padding: '16px 8px',
            backgroundColor: '#f9f9f9ff',
        },
    },
    cells: {
        style: {
            display: "flex",
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },
};

const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #a7a7a7",
        padding: '6px',
    }),
};

const Banner = () => {
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [banner, setBanner] = useState([]);
    const [products, setProducts] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [search, setSearch] = useState("");
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [showimg, setShowImg] = useState(false);
    const [webimg, setWebImg] = useState([]);
    const [showmobimg, setShowMobImg] = useState(false);
    const [mobimg, setMobImg] = useState([]);
    const [activeTab, setActiveTab] = useState('all'); // Added activeTab state

    const handleToggleStatus = async (id) => {
        const previousData = [...banner];
        const currentItem = banner.find(item => item.id === id);
        const newStatus = !currentItem?.isActive;

        setBanner(prevBanner =>
            prevBanner.map(item =>
                item.id === id
                    ? { ...item, isActive: newStatus }
                    : item
            )
        );

        try {
            const response = await new Promise((resolve, reject) => {
                updateBannerStatus(id)(resolve);
            });

            if (response?.data?.statusCode === 200) {
                toast.success("Status updated successfully!");
                if (response.data.banner) {
                    setBanner(prevBanner =>
                        prevBanner.map(item =>
                            item.id === id
                                ? { ...item, ...response.data.banner }
                                : item
                        )
                    );
                }
            } else {
                throw new Error(response?.data?.message || "Failed to update status");
            }
        } catch (error) {
            setBanner(previousData);
            toast.error(error.message);
        }
    };

    const handleShowMobImage = (promoimage) => {
        setShowMobImg(true);
        setMobImg(promoimage)
    }

    const handleCloseImage = () => {
        setShowImg(false);
    }

    const handleCloseMobImage = () => {
        setShowMobImg(false);
    }

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => ((page * limit) - limit) + (index + 1),
            width: '90px',
            center: true
        },
        {
            id: "mobileImage",
            name: "Banner Image",
            selector: (row) => row?.mobileImage,
            cell: (row) => (
                <div className="promocode_img_wrapper d-flex justify-content-center" onClick={() => handleShowMobImage(row?.mobileImage)}>
                    <img src={row?.mobileImage} alt={row?.title} className="img-fluid" />
                </div>
            ),
            grow: 0.5,
            minWidth: '150px',
            center: true
        },
        {
            id: 'title',
            name: 'Title',
            selector: (row) => row?.title,
            cell: (row) => (
                <Tooltip title={row?.title} disableInteractive placement='top'>
                    <div className='text-truncate text-center'>{row?.title}</div>
                </Tooltip>
            ),
            minWidth: '150px',
            center: true
        },
        {
            name: "Status",
            selector: (row) => row.status,
            cell: (row, index) => (
                <div className="status_wrap_datatable">
                    <div className="d-flex justify-content-center">
                        <Switch
                            size=""
                            id={`custom-switch-${index}`}
                            checked={row.isActive === true}
                            onChange={() => handleToggleStatus(row.id)}
                            className="custom-switch"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            center: true,
            width: "130px",
        },
        {
            id: 'createdAt',
            name: 'Created Date',
            selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                    <div className='text-truncate text-center'>{moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')}</div>
                </Tooltip>
            ),
            width: "180px",
            center: true
        },
        {
            id: "action",
            name: "Action",
            cell: (row) => (
                <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center">
                        <div className="d-flex flex-row gap-3" role="button">
                            <Tooltip title="Edit" disableInteractive placement="top">
                                {checkUserPermissions("edit_banners") &&
                                    <div className="edit_icon_bg" onClick={() => handleEditClick(row)}>
                                        <img
                                            src={editIcon}
                                            alt="Edit"
                                            className="edit_icon"
                                        />
                                    </div>
                                }
                            </Tooltip>
                            <Tooltip title="Delete" disableInteractive placement="top">
                                <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                                    <img
                                        src={deleteIcon}
                                        alt="Delete"
                                        className="delete_icon"
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            minWidth: "100px",
            center: true
        },
    ]

    // Validation schema and formik setup remain the same...
    const validationSchema = yup.object().shape({
        title: yup
            .string('Enter your firstName')
            .trim()
            .required('Title is required'),
        webImage: selectedBanner?.id ? yup.string().nullable() : yup.string().required('Image is required'),
        mobileImage: selectedBanner?.id ? yup.string().nullable() : yup.string().required('Image is required'),
    });

    const formik = useFormik({
        initialValues: {
            title: '',
            webImage: '',
            webImage_view: '',
            mobileImage: '',
            mobileImage_view: '',
            productId: '',
            selectedProduct: '',
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {}
            if (!values.selectedProduct) {
                errors.selectedProduct = "Product is required";
            }
            return errors
        },
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            if (values.webImage == '') {
                delete values.webImage;
            }
            delete values.webImage_view;
            if (values.mobileImage == '') {
                delete values.mobileImage;
            }
            delete values.mobileImage_view;
            if (selectedBanner?.id) {
                editBanner(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Banner Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setSelectedBanner(null);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            } else {
                createBanner(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Banner Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedBanner(null);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            }
        },
    });

    const handleShow = () => setShow(true);

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedBanner(null)
    };

    const fetchBannerData = async () => {
        setLoading(true);
        
        const params = {
            page: page, 
            limit: limit, 
            search
        };

        // Add status filter based on activeTab
        if (activeTab === "active") {
            params.isActive = true;
        } else if (activeTab === "inactive") {
            params.isActive = false;
        }

        getBannerListing(params)((response) => {
            if (response?.statusCode === 200) {
                setBanner(response?.data?.banners || []);
                setTotalRows(response?.data?.pagination?.totalItems || 0);
                setLoading(false);
            } else {
                setBanner([]);
                setTotalRows(0);
                setLoading(false);
            }
        });
    };

    let typingTimer;
    const loadOptionsProducts = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 3) {
                    getInventoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        if (response?.statusCode == 200) {
                            resolve(response?.results);
                            setProducts(response?.results)
                        }
                    })
                }
                else {
                    resolve([]);
                }
            }, 300);
        });
    };

    const onProductChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            productId: selectedOption ? selectedOption.value : '',
            selectedProduct: selectedOption,
        });
    };

    const handleEditClick = (row) => {
        navigate(`/edit-banner/${row.id}`);
    };

    const handlePerRowsChange = (newPerPage, currentPage) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (currentPage) => {
        setPage(currentPage);
        setUpdate(!update);
    };

    const handleFilterChange = (filter) => {
        setActiveTab(filter);
        setPage(1); // Reset to first page when changing tabs
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    };

    const handleWebImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            webImage: response,
            webImage_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const handleMobImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            mobileImage: response,
            mobileImage_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const deleteBanner = (id) => {
        setLoading(true);
        deleteBannerItem(id)((response) => {
            if (response?.request?.status == 200) {
                setUpdate(!update);
                setModal(!modal);
                setLoading(false);
                toast.success("Banner deleted successfully")
            } else {
                setLoading(false);
                toast.error("Failed to delete banner");
            }
        });
    };

    useEffect(() => {
        fetchBannerData();
    }, [update, page, limit, activeTab]); // Added activeTab to dependencies

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial) {
                setPage(1);
                setUpdate(!update);
            } else {
                setInitial(true);
            }
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    return (
        <>
            <div>
                <div className="page-header-sticky d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="d-flex align-items-center">
                        <h3 className="mb-0 fw-bolder">Banners</h3>
                    </div>

                    <div className="d-flex align-items-center">
                        <Button className="request_btn" onClick={() => navigate(`/create-banner`)}>
                            <FiPlus size={18} strokeWidth={3} />
                            Add New Banner
                        </Button>
                    </div>
                </div>
                
                {/* Added Filter Tabs Section */}
                <div className="row">
                    <div className="col-12">
                        <div className="shadow-none mb-2">
                            <div className="filter_wrapper">
                                <Nav
                                    variant="tabs"
                                    defaultActiveKey="all"
                                    activeKey={activeTab}
                                    onSelect={setActiveTab}
                                    className="custom-order-tabs"
                                >
                                    <Nav.Item>
                                        <Nav.Link
                                            eventKey="all"
                                            className={`fs-7 fw-semibold ${activeTab === 'all' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                            style={{
                                                padding: '12px 24px',
                                                backgroundColor: activeTab === 'all' ? '#f8f9fa' : 'transparent',
                                                transition: 'all 0.3s ease',
                                                color: activeTab === 'all' ? '#000' : '#6c757d'
                                            }}
                                            onClick={() => handleFilterChange("all")}
                                        >
                                            All
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            eventKey="active"
                                            className={`fs-7 fw-semibold ${activeTab === 'active' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                            style={{
                                                padding: '12px 24px',
                                                backgroundColor: activeTab === 'active' ? '#f8f9fa' : 'transparent',
                                                transition: 'all 0.3s ease',
                                                color: activeTab === 'active' ? '#000' : '#6c757d'
                                            }}
                                            onClick={() => handleFilterChange("active")}
                                        >
                                            Active
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            eventKey="inactive"
                                            className={`fs-7 fw-semibold ${activeTab === 'inactive' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                            style={{
                                                padding: '12px 24px',
                                                backgroundColor: activeTab === 'inactive' ? '#f8f9fa' : 'transparent',
                                                transition: 'all 0.3s ease',
                                                color: activeTab === 'inactive' ? '#000' : '#6c757d'
                                            }}
                                            onClick={() => handleFilterChange("inactive")}
                                        >
                                            Inactive
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d_grid_wrapper"></div>
            </div>

            <div className='col-12'>
                <Box className="products-and-options" sx={{ mt: 1 }}>
                    <Paper square className='shadow-none border border-blue-grey-200'>
                        <div>
                            <DataTable
                                onRowClicked={(row) => handleEditClick(row)}
                                columns={columns}
                                data={banner}
                                progressPending={loading}
                                progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                pagination
                                paginationServer
                                pointerOnHover
                                highlightOnHover
                                paginationTotalRows={totalRows}
                                paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                paginationPerPage={limit}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                paginationDefaultPage={page}
                                customStyles={queueDatatableCustomStyles}
                            />
                        </div>
                    </Paper>
                </Box>
            </div>

            {/* Rest of the modals and components remain the same */}
            <CreateBanner
                show={show}
                handleClose={handleClose}
                handleShow={handleShow}
                loading={loading}
                loadOptionsProducts={loadOptionsProducts}
                products={products}
                onProductChange={onProductChange}
                customStyles={customStyless}
                formik={formik}
                selectedBanner={selectedBanner}
                handleWebImageChange={handleWebImageChange}
                handleMobImageChange={handleMobImageChange}
                // handleSubImageChange={handleSubImageChange}
            />
            <CustomisedModal
                isOpen={modal}
                customClass={"policy_modal"}
                toggle={toggleModal}
            >
                <h5>Are you sure you want to remove this item?</h5>
                <div className="policy_Agree">
                    <Button
                        onClick={() => {
                            setModal(!modal);
                        }}
                        size="lg"
                        className="btn_cancel"
                    >
                        Cancel
                    </Button>
                    <Button
                        size="lg"
                        className="btn"
                        onClick={() => deleteBanner(deletingId)}
                        disabled={loading}
                    >
                        Delete
                    </Button>
                </div>
            </CustomisedModal>

            <Modal
                show={showimg}
                onHide={handleCloseImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={webimg} alt='' className="img-fluid" />
                </div>
            </Modal>

            <Modal
                show={showmobimg}
                onHide={handleCloseMobImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={mobimg} alt='' className="img-fluid" />
                </div>
            </Modal>
        </>
    )
}

export default Banner